/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it


import React from 'react';
import { checkUrlFunction } from './src/helpers/CheckUrlFunction';

// export const onClientEntry = () => checkUrlFunction();


// export const onClientEntry = async () => {
//     if (typeof IntersectionObserver === "undefined") {
//       await import("intersection-observer");
//       console.log("IntersectionObserver polyfilled ;)");
//     }
//   };

// // gatsby-browser.js
// exports.onRouteUpdate = () => {
//   window.locations = window.locations || [document.referrer]
//   locations.push(window.location.href)
//   window.previousPath = locations[locations.length - 2]
// }





